/** Validaciones reutilizables para formularios. */

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Valida que el valor (string) tenga al menos un carácter no en blanco.
 * @param {string} message
 * @returns {(value: string) => true | string}
 */
export const requireNonEmpty = (message = "No puede estar vacío.") =>
  (v) => (typeof v === "string" && v.trim().length > 0) || message;

/**
 * Reglas estándar de email para usar con react-hook-form `register`.
 * @param {string} requiredMessage
 */
export const emailRules = (requiredMessage = "El correo es obligatorio.") => ({
  required: requiredMessage,
  maxLength: { value: 200, message: "Correo demasiado largo." },
  pattern: { value: EMAIL_REGEX, message: "Introduce un correo válido." },
});
